// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"b6b6f5e6","977":"5784d5ba"}[chunkId] + ".chunk.js");